import Gone from "./ErrorPages/Gone";
import NotFound from "./ErrorPages/NotFound";
import ServerError from "./ErrorPages/ServerError";

function ErrorBoundary(props) {
  const { error } = props;
  if (error.message === "410") {
    return <Gone />;
  }
  if (error.message === "404") {
    return <NotFound />;
  }
  return <ServerError />;
}

export default ErrorBoundary;
